import React from "react";
import { colorLabel, isValidHex, isLightHex } from "../../lib/colorHex";

/**
 * A cart / order line's colour, as the shopper should read it.
 *
 * Swatch-only variants carry a hex as their colour (e.g. "#ff0000") —
 * render the swatch plus a readable name ("Red") instead of the raw
 * hex. Seller-entered names ("Warm Honey Beige") render unchanged.
 * Display only: the stored value stays the variant's identity key.
 */
export default function ColorValue({ value, className = "" }) {
  if (!value) return null;
  return (
    <>
      {isValidHex(value) && (
        <span
          className={`inline-block w-3 h-3 mr-1 rounded-full border align-middle ${
            isLightHex(value) ? "border-[hsl(var(--kb-border))]" : "border-black/10"
          }`}
          style={{ background: value }}
          aria-hidden="true"
        />
      )}
      <b className={className}>{colorLabel(value)}</b>
    </>
  );
}
